import { render, staticRenderFns } from "./horizontalMiniIconMenu.vue?vue&type=template&id=6c222770&scoped=true&"
import script from "./horizontalMiniIconMenu.vue?vue&type=script&lang=js&"
export * from "./horizontalMiniIconMenu.vue?vue&type=script&lang=js&"
import style0 from "./horizontalMiniIconMenu.vue?vue&type=style&index=0&id=6c222770&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c222770",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ALink: require('/app/components/aLink.vue').default})
